import { useParams, Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

export function Confirmation() {
  const { id } = useParams();
  return (
    <div className="app-shell">
      <div className="screen-content" style={{ justifyContent: 'center', alignItems: 'center', minHeight: '100vh', textAlign: 'center' }}>
        <CheckCircle2 size={56} color="var(--success)" strokeWidth={1.5} />
        <div style={{ fontSize: 18, fontWeight: 800 }}>Candidature envoyée</div>
        <div style={{ fontSize: 13.5, color: 'var(--text-secondary)' }}>
          L'établissement va examiner votre profil. Vous serez notifié dès qu'une décision est prise.
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '100%', marginTop: 12 }}>
          <Link to={`/extra/missions/${id}`} className="btn btn-secondary">Voir la mission</Link>
          <Link to="/extra" className="btn btn-primary">Retour à l'accueil</Link>
        </div>
      </div>
    </div>
  );
}
